import React from 'react';
import { Header } from './Header';

interface ITopNavProps {
    theme: string;
    toggleTheme: () => void;
}

export const TopNav: React.FC<ITopNavProps> = ({ theme, toggleTheme }) => {
  return (
    <Header theme={theme} toggleTheme={toggleTheme} />
  );
};

export default TopNav;
